import React, { useState, useEffect, Fragment } from 'react';
import { useParams } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import TableComponent from 'components/Table/Table';

import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Add, Delete, Event, Remove } from '@material-ui/icons';
import CardBody from 'components/Card/CardBody';
import CardIcon from 'components/Card/CardIcon';

import { wsGet, wsGetAll } from 'services/WService';
import { Toasty, useToasty } from 'hooks/Toasty';
import { useModal } from 'hooks/useModal';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import { Detail, ModalDetail } from './SellerDetailComponents';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import RegularButton from 'components/CustomButtons/Button';
import AddSellerMarkModal from './AddSellerMarkModal';
import RemoveSellerMarkModal from './RemoveSellerMarkModal';
import { wsRemove } from 'services/WService';

const useRowStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

export default function SellerDetail() {
  const { id } = useParams();
  const classes = useRowStyles();
  const [notify, showNotify] = useToasty();
  const [model, setOpen] = useModal();
  const [markModel, setMarkOpen] = useModal();
  const [markRemovidasModel, setMarkRemovidasOpen] = useModal();

  const [saleForce, setSaleForce] = useState({ sale_forces: [] });
  const [canals, setCanals] = useState([]);
  const [marks, setMarks] = useState([]);
  const [marksRemovidas, setMarksRemovidas] = useState([]);

  async function listSaleForces() {
    let response = await wsGet('base/seller', id);
    if (response.success) {
      setSaleForce(response.data);
      setMarks(response.data.marks);
      setMarksRemovidas(response.data.excluded_marks);
    }
  }

  async function listCanals() {
    let response = await wsGetAll('base/canal');
    if (response.success) setCanals(response.data);
  }

  async function removeMark(mark) {
    let res = await wsRemove(`base/seller/${id}/mark/${mark.id}`);
    if (res.success) {
      setMarks(res.data);
      showNotify(res.message);
    }
  }

  async function deleteRemoveMark(markRemovida) {
    let res = await wsRemove(`base/seller/${id}/excluded-mark/${markRemovida.id}`);
    if (res.success) {
      setMarksRemovidas(res.data);
      showNotify(res.message);
    }
  }

  // #region funcion para el modal de fuerza
  const [dataChanging, setDataChanging] = useState({});
  const handleChange = (field, value) => {
    setDataChanging({ ...dataChanging, [field]: value });
  };
  // #endregion

  useEffect(() => {
    listSaleForces();
    listCanals();
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />
      <AddSellerMarkModal
        model={markModel}
        setOpen={setMarkOpen}
        setSellerMarks={setMarks}
        showNotify={showNotify}
      />
      <RemoveSellerMarkModal
        model={markRemovidasModel}
        setOpen={setMarkRemovidasOpen}
        setSellerExcludedMarks={setMarksRemovidas}
        showNotify={showNotify}
      />
      {model.open ? (
        <ModalBase
          title="Fuerza de venta"
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={listSaleForces}
          dataChanging={dataChanging}
          setDataChanging={setDataChanging}
          dataForce={{ base_seller_id: id }}
          entity="base/sale-force-detail"
        >
          <ModalDetail seller={{ id, SlpName: saleForce.SlpName }} handleChange={handleChange} />
        </ModalBase>
      ) : undefined}

      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={ConstantPermissions.BASE_SELLERS_STORE}
            component={
              <CardIcon color="primary">
                <Event style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon pointer color="success" onClick={() => setOpen({})}>
              <Add style={{ color: 'white' }} />
            </CardIcon>
          </AllowedGuard>

          <h4 className={classes.cardIconTitle}>
            <b>
              Fuerzas de venta: (<span style={{ fontSize: '14px' }}>{saleForce.SlpName}</span>)
            </b>
          </h4>
        </CardHeader>
        <CardBody>
          <div
            style={{
              overflow: 'auto',
              maxHeight: '100Vh',
              border: '1px solid #e0e0e0',
              borderRadius: '5px',
            }}
          >
            <Table aria-label="collapsible table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>Zona</TableCell>
                  <TableCell>Almacén</TableCell>
                  <TableCell>Mesa</TableCell>
                  <TableCell>Estado</TableCell>
                  <TableCell align="center">Agregar canal</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {saleForce.sale_forces?.map((saleF) => {
                  const res = canals?.filter(
                    (item) => !saleF.details?.some((d) => d.base_canal_id == item.id),
                  );
                  return (
                    <Detail
                      key={saleF.id}
                      saleForce={{ ...saleF, base_seller_id: id }}
                      reload={listSaleForces}
                      showNotify={showNotify}
                      canals={res}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <CardContainer
        title={`Marcas (${marks.length})`}
        icon={<Add />}
        onClick={() => {
          setMarkOpen(saleForce);
        }}
      >
        <TableComponent
          tableHead={['#', 'Código', 'Marca', 'Acciones']}
          tableData={marks.map((mark, index) => {
            return [
              index + 1,
              mark.code,
              mark.description,
              <RegularButton color="danger" justIcon round onClick={() => removeMark(mark)}>
                <Delete />
              </RegularButton>,
            ];
          })}
        />
      </CardContainer>
      
      <CardContainer
        title={`Marcas Removidas (${marksRemovidas.length})`}
        icon={<Remove />}
        onClick={() => {
          setMarkRemovidasOpen(saleForce);
        }}
      >
        <TableComponent
          tableHead={['#', 'Código', 'Marca Removidas', 'Acciones']}
          tableData={marksRemovidas.map((excludedMark, index) => {
            return [
              index + 1,
              excludedMark.code,
              excludedMark.description,
              <RegularButton color="danger" justIcon round onClick={() => deleteRemoveMark(excludedMark)}>
                <Delete />
              </RegularButton>,
            ];
          })}
        />
      </CardContainer>
    </Fragment>
  );
}
